<template>
  <div>
    <p class="cp-help-text">The items was added to shopping cart.</p>
    <br>
    <div class="columns">
      <div class="column is-12-mobile is-7 is-7-desktop cp-left-column">
        <table class="table is-fullwidth" style="margin-bottom: 0">
          <thead>
            <tr>
              <th class="has-text-left" style="padding-left: 0;">Product</th>
              <th class="has-text-left">Quantity</th>
              <th class="has-text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) of cartProducts" v-bind:key="index">
              <td style="padding-bottom: 30px; padding-left: 0;">
                {{product.cpProductInfo.name}}
                <br>
                <small v-for="option in getProductOptions(index)" v-bind:key="option"> – {{option}}<br></small>
              </td>
              <td class="has-text-left">{{product.quantity}}</td>
              <td class="has-text-left" style="padding: 11px 0 0;">
                <div class="buttons has-text-right is-pulled-right">
                  <b-button size="is-small" v-on:click="editProduct(index)">
                    <b-icon pack="fas" icon="pencil-alt" size="is-small"/>
                  </b-button>
                  <b-button size="is-small" v-on:click="removeProduct(index)">
                    <b-icon pack="fas" icon="trash-alt" size="is-small"/>
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="is-pulled-right">
          <b-button v-on:click="addProduct()">
            <b-icon pack="fas" icon="plus" size="is-small" style="margin-right:0px;"/> Add product
          </b-button>
        </div>

      </div>

      <div class="column is-12-mobile is-5 is-5-desktop cp-right-column">
        <OrderOverview :priceCheck="orderData.priceCheckResponse" />
      </div>
    </div>
  </div>
</template>

<script>
import OrderOverview from '@/components/order-create/OrderOverview'
import ProductMixin from '@/mixins/ProductMixin'
import _ from 'lodash'

export default {
  name: 'Cart',
  mixins: [ProductMixin],
  components: {
    OrderOverview
  },

  data () {
    return {
      orderData: {},
      cartProducts: []
    }
  },

  created () {
    this.orderData = this.$store.getters['cpOrder/allData']
    this.cartProducts = this.$store.getters['cart/products']
  },

  methods: {
    removeProduct: function (index) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to <b>remove</b> the product from cart?',
        confirmText: 'Remove product',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('cart/removeProduct', index)

          if (this.cartProducts.length > 0) {
            this.$store.dispatch('cpOrder/priceCheckForCartItems')
          }
        }
      })
    },

    addProduct: function () {
      this.$store.dispatch('cpOrder/clearProductData')
      this.$emit('goToStep', 0)
    },

    editProduct: function (index) {
      const productData = _.cloneDeep(this.cartProducts[index])
      this.$store.dispatch('cpOrder/setProductData', productData)
      this.$store.dispatch('cpOrder/enableEditMode', index)
      this.$emit('goToStep', 0)
    }
  }
}
</script>
